import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=516e69c7&"
import script from "./Notification.vue?vue&type=script&lang=ts&"
export * from "./Notification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports